<template>
  <LogInfoWindow ref="confirm"/>

  <v-container class="w-auto mx-15" fluid>
    <v-row class="justify-space-between mb-6">
      <LogEventsFilter
        :table-model="tableModel"
        :event-list="eventList"
      />
    </v-row>
    <v-row>
      <LogEventsGrid
        :page-sizes-list="pageSizesList"
        :table-model="tableModel"
        :confirm-dlg="confirm"
      />
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import api from '@/api';
import { toast } from '@/lib/toast';
import { ref, reactive, onBeforeMount } from 'vue';
import RemoteTableModel from '@/components/RemoteTableModel';
import LogInfoWindow from "@/components/LogInfo.vue";
import LogEventsGrid from '@/components/eventsLogs/LogEventsGrid.vue';
import LogEventsFilter from '@/components/eventsLogs/LogEventsFilter.vue';

const confirm = ref({});
const eventList = ref([]);

const pageSizesList = ref([
  {title: '15', value: 15},
  {title: '50', value: 50},
  {title: '100', value: 100},
  {title: '500', value: 500},
]);

const tableModel = reactive(
  new RemoteTableModel({
    headers: [
      { title: 'ID события', key: 'id', sortable: false },
      { title: 'Дата и время', key: 'createdAt', sortable: true },
      { title: 'Действие', key: 'eventName', sortable: false },
      { title: 'Пользователь-субъект', key: 'madeByUsername', sortable: false },
      { title: 'Статус', key: 'success', sortable: false },
      { title: '', key: 'actions', sortable: false },
    ],
    loader(query) {
      const queryParams = {
        ...query.searchParams,
        ...query.range,
      };

      if (query.sort && query.sort.length > 0) {
        query.sort.forEach(({ column, order }) => {
          queryParams[`order[${column}]`] = order.toLowerCase();
        });
      }

      return api.get('/api/event', queryParams);
    },
    options: {
       sortBy: [
          { key: 'createdAt', order: 'desc' }
        ],
      isApiRequest: true,
      itemsPerPage: 15,
    },
  })
);

const loadEventList = async () => {
  try {
    const { results } = await api.get('/api/vocab/event');
    eventList.value = results;
  } catch (e) {
    toast.error(e.message);
  }
};

onBeforeMount(() => {
  loadEventList();
});
</script>